import { Plan, Tier } from "@/types";
import { FC, ReactNode, useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { TierItem } from "./TierItem";
import { first, isEmpty } from "lodash";
import { CgSpinnerTwo } from "react-icons/cg";
import { Button } from "./Buttons";
import { Link } from "react-router-dom";

type SelectTierProps = {
  loading?: boolean;
  title: ReactNode;
  plan: Plan;
  onClickSubmit: (tier: Tier) => void;
};
export const SelectTier: FC<SelectTierProps> = ({
  loading = false,
  title,
  plan: { id, revenue, tiers },
  onClickSubmit = () => null,
}) => {
  const [tier, setTier] = useState<Tier>();

  useEffect(() => {
    if (Object.values(tiers).length === 1) {
      setTier(first(Object.values(tiers)));
    }
  }, [tiers]);

  return (
    <div className="flex-1 flex flex-col gap-5 xl:gap-10">
      <div className="flex flex-col gap-5">
        <div className="flex items-center text-sm xl:text-[22px] font-medium leading-none">
          <span className="text-secondary capitalize">{id}</span>&nbsp;
          <span className="text-[#E0E0E0]">{revenue}</span>
        </div>

        <div className="font-dmSans text-white text-[32px] xl:text-[38px] font-bold leading-[44px] inline-flex flex-col">
          {title}
        </div>
      </div>

      <div className="flex-1 flex flex-col overflow-y-auto gap-4">
        {Object.values(tiers).map((t) => (
          <TierItem
            key={t.id}
            tier={t}
            // hideIcon={Object.values(tiers).length === 1}
            selected={!!tier && tier.id === t.id}
            onClick={() => setTier(t)}
          />
        ))}
      </div>

      <div className="flex flex-col gap-5 mt-4 xl:mt-10">
        <Button
          className="flex items-center justify-center gap-2 md:px-12 py-5 text-xl md:text-2xl"
          onClick={() => !!tier && onClickSubmit(tier)}
          disabled={isEmpty(tier)}
          type="submit"
        >
          Continue
          {loading ? (
            <span className="animate-spin">
              <CgSpinnerTwo />
            </span>
          ) : (
            <FaArrowRight />
          )}
        </Button>

        <Link
          className="text-white underline cursor-pointer font-bold leading-[45px] text-[19px] mx-auto"
          to="/pricing"
        >
          Show All Plans & Pricing
        </Link>
      </div>
    </div>
  );
};
